import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withTranslation } from 'react-i18next';
import { trunksQttySelector } from '../../app/selectors/appSelectors';
import { trunksSelector, isSummaryActiveStep } from '../selectors/wizardSelectors';
import { updateStep } from '../actions/wizardActions';
import Trunks from '../components/Trunks/Trunks';

const mapStateToProps = createStructuredSelector({
    editable: isSummaryActiveStep,
    formData: trunksSelector,
    trunksQtty: trunksQttySelector
});

const mapDispatchToProps = { updateStep };

export default withTranslation(['common', 'validations'])(
    connect(mapStateToProps, mapDispatchToProps)(Trunks)
);
